/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaExpressOutboundInfoVo } from './KoreaExpressOutboundInfoVo';
import {
    KoreaExpressOutboundInfoVoFromJSON,
    KoreaExpressOutboundInfoVoFromJSONTyped,
    KoreaExpressOutboundInfoVoToJSON,
    KoreaExpressOutboundInfoVoToJSONTyped,
} from './KoreaExpressOutboundInfoVo';

/**
 * 
 * @export
 * @interface ResponseKoreaExpressOutboundInfoVo
 */
export interface ResponseKoreaExpressOutboundInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKoreaExpressOutboundInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKoreaExpressOutboundInfoVo
     */
    message?: string;
    /**
     * 
     * @type {KoreaExpressOutboundInfoVo}
     * @memberof ResponseKoreaExpressOutboundInfoVo
     */
    data?: KoreaExpressOutboundInfoVo;
}

/**
 * Check if a given object implements the ResponseKoreaExpressOutboundInfoVo interface.
 */
export function instanceOfResponseKoreaExpressOutboundInfoVo(value: object): value is ResponseKoreaExpressOutboundInfoVo {
    return true;
}

export function ResponseKoreaExpressOutboundInfoVoFromJSON(json: any): ResponseKoreaExpressOutboundInfoVo {
    return ResponseKoreaExpressOutboundInfoVoFromJSONTyped(json, false);
}

export function ResponseKoreaExpressOutboundInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKoreaExpressOutboundInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KoreaExpressOutboundInfoVoFromJSON(json['data']),
    };
}

export function ResponseKoreaExpressOutboundInfoVoToJSON(json: any): ResponseKoreaExpressOutboundInfoVo {
    return ResponseKoreaExpressOutboundInfoVoToJSONTyped(json, false);
}

export function ResponseKoreaExpressOutboundInfoVoToJSONTyped(value?: ResponseKoreaExpressOutboundInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KoreaExpressOutboundInfoVoToJSON(value['data']),
    };
}

